"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("@/Components/common/Checkbox"));
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var react_i18next_1 = require("react-i18next");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var RenderingOptionsSidebar = function (_a) {
    var appData = _a.appData, onAppDataUpdate = _a.onAppDataUpdate;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var logger = q_play_core_1.logManager.getLogger();
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var _b = (0, react_1.useState)(appData.visible), visible = _b[0], setVisible = _b[1];
    var _c = (0, react_1.useState)(appData.persist_app_across_slides), persistAcrossSlides = _c[0], setPersistAcrossSlides = _c[1];
    var _d = (0, react_1.useState)(false), snackbarOpen = _d[0], setSnackbarOpen = _d[1];
    var _e = (0, react_1.useState)(""), snackbarMessage = _e[0], setSnackbarMessage = _e[1];
    var _f = (0, react_1.useState)("success"), snackbarSeverity = _f[0], setSnackbarSeverity = _f[1];
    var handleCloseSnackbar = function () {
        setSnackbarOpen(false);
    };
    var handleVisibleChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newValue, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newValue = e.target.checked;
                    setVisible(newValue);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dataProvider.update("apps/visibility", {
                            id: appData.id,
                            data: { visible: newValue },
                            previousData: appData,
                        })];
                case 2:
                    _a.sent();
                    onAppDataUpdate === null || onAppDataUpdate === void 0 ? void 0 : onAppDataUpdate({ visible: newValue });
                    setSnackbarMessage(t("App visibility updated successfully"));
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    logger.error(t("Error updating app visibility"), err_1);
                    setSnackbarMessage(t("Failed to update visibility"));
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handlePersistAcrossSlidesChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newValue, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newValue = e.target.checked;
                    setPersistAcrossSlides(newValue);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dataProvider.update("app-editor/app-versions/".concat(appData.id, "/").concat(appData.version, "/persist"), {
                            id: "",
                            data: { persist_app_across_slides: newValue },
                            previousData: appData,
                        })];
                case 2:
                    _a.sent();
                    onAppDataUpdate === null || onAppDataUpdate === void 0 ? void 0 : onAppDataUpdate({ persist_app_across_slides: newValue });
                    setSnackbarMessage(t("Persist app across slides updated successfully"));
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    logger.error(t("Error updating persist app across slides"), err_2);
                    setSnackbarMessage(t("Failed to update persist app across slides"));
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "ns-font-family-bold", style: {
                textAlign: "center",
                color: "var(--info-color)",
                marginTop: "20px",
                fontSize: "17px",
            } },
            react_1.default.createElement("p", { style: { marginBottom: "5px" } }, t("Rendering Options"))),
        react_1.default.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                padding: "15px",
            } },
            react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: "10px" } },
                react_1.default.createElement("label", { style: { color: "var(--info-color)" } },
                    t("Visible"),
                    ":"),
                react_1.default.createElement(Checkbox_1.default, { checked: visible, onChange: handleVisibleChange })),
            react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: "10px" } },
                react_1.default.createElement("label", { style: { color: "var(--info-color)" } },
                    t("Persist App Across Slides"),
                    ":"),
                react_1.default.createElement(Checkbox_1.default, { checked: persistAcrossSlides, onChange: handlePersistAcrossSlidesChange }))),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: handleCloseSnackbar, message: snackbarMessage, severity: snackbarSeverity })));
};
exports.default = RenderingOptionsSidebar;
